export default __webpack_public_path__ + "static/media/miniatura-spacer.a1cc789b.png";